import React from "react";
import { FaTwitter, FaFacebookF, FaInstagram, FaEnvelope, FaLinkedinIn, FaFacebook } from 'react-icons/fa';
import "../css/footer.css"; // ✅ Import the CSS
import logo from "../imgs/LME.jpg"; 
import facebook from "../imgs/facebook.png"; // ✅ Import the Facebook icon
import twitter from "../imgs/twitter1.png"; // ✅ Import the Twitter icon
import instagram from "../imgs/instagram.png"; // ✅ Import the Instagram icon
import linkedin from "../imgs/linkdin.png"; // ✅ Import the LinkedIn icon
import mail from "../imgs/mail.png"; // ✅ Import the Mail icon 

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Column 1: Logo & About */}
        <div className="footer-logo">
          <img src={logo} alt="Lotus Meta Logo" />
          <h2>Lotus Meta Entertainment</h2>
          <p>Redefining the Future of Entertainment</p>
          <p className="tagline">
            "Innovative Ventures in NFTs, Metaverse, and Content Creation"
          </p>
        </div>

        {/* Column 2: Connect & Social */}
        <div className="footer-connect">
          <h3>Connect</h3>
       <div className="footer-social">
  <a href="https://twitter.com/LotusMeta_Ent" target="_blank" rel="noopener noreferrer"><FaTwitter /> <img src={twitter} /> </a>
  <a href="https://www.facebook.com/profile.php?id=61556278206989" target="_blank" rel="noopener noreferrer"><FaFacebook/> <img src={facebook} /></a>
  <a href="https://www.instagram.com/lotusmeta_ent/?next=%2F" target="_blank" rel="noopener noreferrer"><FaInstagram /><img src={instagram} /></a>
  <a href="mailto:ep@lotusmeta.com"><FaEnvelope /><img src={mail} /></a>
  <a href="https://www.linkedin.com/company/lotus-meta-entertainment/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /><img src={linkedin} /></a>
</div>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="footer-bottom">
        © 2026 Lotus Meta Entertainment – All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
